<div class="video-list-container div-right-panel-component">
  @for (video of vidoeList; track video) {
  <div class="video-card-container">
    <p-card [matTooltip]="video?.description | htmlSanitizer: 200" [class]="styleClassName" (click)="onVideoClick(video)">
      <p-header> {{ video?.title | htmlSanitizer: 50 }} </p-header>
      <div class="card-content">
        <img class="thumbnail" [src]="video?.thumbnail" alt="{{ video?.title }}" />
        <!-- <div class="text-content">
          <p>{{ video?.description | htmlSanitizer : 120 }}</p>
        </div> -->
      </div>
    </p-card>
  </div>
  }
</div>
